import { DateTime } from "luxon";
import { useRef, useState } from "react";
import Avatar from "../Avatar";
import MenuFlottant from "../MenuFlottant/MenuFlottant";

// Assignation du lead : pastille (photo et nom) et menu avec recherche par nom.
// Mêmes règles que l'ancien sélecteur : seuls les gestionnaires avec un rôle
// et un contrat en cours sont proposés (plus celui déjà assigné), et une
// réassignation demande confirmation. `filtrerCandidat` restreint encore la
// liste selon la page (les leads DOMI n'acceptent pas de partenaire). Pas de
// retrait d'assignation : graal exige un utilisateur (422 sinon).
const AssignationLead = ({ leadId, assignedTo, managers = [], onAssigner, filtrerCandidat = () => true, portee = "carte" }) => {
  const [ouvert, setOuvert] = useState(false);
  const [recherche, setRecherche] = useState("");
  const refBouton = useRef(null);

  const assigneA = assignedTo || "";
  const assigne = managers.find((m) => m.id === assigneA);

  const candidats = managers
    .filter((manager) => {
      if (!manager.roles || manager.roles.length === 0) return false;
      if (manager.id === assigneA) return true;
      if (manager.contractEndAt && DateTime.now() > DateTime.fromISO(manager.contractEndAt)) return false;
      return filtrerCandidat(manager);
    })
    .sort((a, b) => (a.id === assigneA ? -1 : b.id === assigneA ? 1 : 0));
  const filtre = recherche.trim().toLowerCase();
  const proposes = candidats.filter((m) => !filtre || (m.fullName || "").toLowerCase().includes(filtre));

  const fermer = () => {
    setOuvert(false);
    setRecherche("");
  };

  const choisir = (id) => {
    fermer();
    if (id === assigneA) return;
    if (assigneA) {
      const nouveau = managers.find((m) => m.id === id);
      const message = `Cette demande est actuellement assignée à ${assigne ? assigne.fullName : "quelqu'un"}.\n\nVoulez-vous la réassigner à ${nouveau ? nouveau.fullName : "cette personne"} ?`;
      if (!window.confirm(message)) return;
    }
    onAssigner(id);
  };

  return (
    <div className="la-ancre">
      <button
        ref={refBouton}
        type="button"
        className={`la-assigne ${assigne ? "" : "la-assigne--vide"}`.trim()}
        aria-haspopup="menu"
        aria-expanded={ouvert}
        aria-label={assigne ? `Assigné à ${assigne.fullName}. Changer l'assignation` : "Assigner le lead"}
        onClick={() => (ouvert ? fermer() : setOuvert(true))}
      >
        {assigne ? (
          <>
            <Avatar id={assigne.id} width={24} height={24} className="la-assigne__avatar" />
            <span className="la-assigne__nom">{assigne.fullName}</span>
          </>
        ) : (
          <>
            <i className="fa fa-user-plus" aria-hidden="true" />
            <span className="la-assigne__nom">Assigner à…</span>
          </>
        )}
        <i className="fa fa-chevron-down la-assigne__chevron" aria-hidden="true" />
      </button>
      <MenuFlottant
        ouvert={ouvert}
        onFermer={fermer}
        refBouton={refBouton}
        titre="Assigner le lead"
        aligne={portee === "panneau" ? "gauche" : "droite"}
        largeur={260}
      >
        <label className="sr-only" htmlFor={`la-recherche-${leadId}-${portee}`}>
          Rechercher une personne
        </label>
        <input
          id={`la-recherche-${leadId}-${portee}`}
          type="search"
          className="la-menu__recherche"
          placeholder="Rechercher une personne…"
          autoComplete="off"
          value={recherche}
          onChange={(e) => setRecherche(e.target.value)}
        />
        <div className="la-menu__liste">
          {proposes.length === 0 && <div className="la-menu__vide">Aucune personne ne correspond.</div>}
          {proposes.map((m) => (
            <button
              key={m.id}
              type="button"
              role="menuitemradio"
              aria-checked={m.id === assigneA}
              className="la-menu__item"
              onClick={() => choisir(m.id)}
            >
              <Avatar id={m.id} width={24} height={24} className="la-assigne__avatar" />
              {m.fullName}
              {m.id === assigneA && <i className="fa fa-check la-menu__coche" aria-hidden="true" />}
            </button>
          ))}
        </div>
      </MenuFlottant>
    </div>
  );
};

export default AssignationLead;
